<template>
  <v-dialog
    v-model="value"
    max-width="560px"
    persistent
    scrollable
    content-class="case-dialog"
  >
    <v-card class="rounded-lg" style="border-radius: 12px !important; overflow: hidden;">
      <div v-if="loading" class="loader-overlay">
        <div class="loader-content">
          <v-progress-circular indeterminate size="48" width="4" color="#009E60" />
          <div class="loader-text mt-3">Сохранение кейса...</div>
        </div>
      </div>

      <!-- Header -->
      <v-card-title
        class="px-6 pt-5 pb-4 d-flex justify-space-between align-center"
        style="border-bottom: 1px solid #DEE1EA;"
      >
        <span class="text-h6 font-weight-bold" style="color: #25325F;">
          {{ caseEditModal.id ? 'Редактировать кейс' : 'Новый кейс' }}
        </span>
        <v-btn icon small @click="closeModal">
          <v-icon style="color: #9BA1B5;">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Body -->
      <v-card-text class="px-6 pt-5 pb-2">
        <v-form ref="form" lazy-validation>

          <!-- Компетенция -->
          <div class="mb-4">
            <label class="case-label">Компетенция <span style="color:#EC2E2E;">*</span></label>
            <v-autocomplete
              v-model="form.competence"
              :items="competencies"
              item-text="name"
              item-value="id"
              outlined
              dense
              :rules="[v => !!v || 'Выберите компетенцию']"
              placeholder="Выберите компетенцию"
              class="case-input mt-1"
              no-data-text="Нет компетенций"
            />
          </div>

          <!-- Название -->
          <div class="mb-4">
            <label class="case-label">Название <span style="color:#EC2E2E;">*</span></label>
            <v-text-field
              v-model="form.name"
              outlined
              dense
              :rules="[v => !!v && v.trim().length > 0 || 'Введите название']"
              placeholder="Введите название кейса"
              class="case-input mt-1"
            />
          </div>

          <!-- Описание -->
          <div class="mb-2">
            <label class="case-label">Описание</label>
            <v-textarea
              v-model="form.description"
              outlined
              dense
              hide-details
              rows="4"
              no-resize
              placeholder="Краткое описание ситуации кейса"
              class="case-input mt-1"
            />
          </div>

        </v-form>
      </v-card-text>

      <v-divider />

      <!-- Footer -->
      <v-card-actions class="px-6 py-4 d-flex justify-end" style="gap: 12px;">
        <v-btn
          text height="40" class="px-5"
          style="color: #6B759A; font-weight: 600;"
          @click="closeModal"
        >
          Отмена
        </v-btn>
        <v-btn
          depressed height="40" class="px-8"
          color="#009E60" dark
          style="font-weight: 600; border-radius: 8px;"
          @click="save"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'CaseEditModal',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Boolean, default: false },
    caseItem: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { competence: null, name: '', description: '' },
    };
  },
  computed: {
    ...mapGetters({
      competencies: 'diagnostics/diagnotics/libraryCompetencies',
      caseEditModal: 'diagnostics/diagnotics/caseEditModal',
    }),
  },
  watch: {
    caseItem: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            competence: val.competence || null,
            name: val.name || '',
            description: val.description || '',
          };
        } else {
          this.resetForm();
        }
      },
    },
    value: {
      immediate: true,
      handler(val) {
        if (!val) this.resetForm();
      },
    },
  },
  methods: {
    ...mapMutations({
      SET_CASE_SHOW_MODAL: 'diagnostics/diagnotics/SET_CASE_SHOW_MODAL',
      SET_CASE_ID_MODAL: 'diagnostics/diagnotics/SET_CASE_ID_MODAL',
    }),
    closeModal() {
      this.SET_CASE_SHOW_MODAL(false);
      this.SET_CASE_ID_MODAL(null);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$emit('save', JSON.parse(JSON.stringify(this.form)));
    },
    resetForm() {
      this.form = { competence: null, name: '', description: '' };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
  },
};
</script>

<style lang="scss">
.case-dialog { max-height: 90vh; }

.case-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #25325F;
}

.case-input {
  .v-input__slot {
    border-radius: 8px !important;
    background-color: #ffffff !important;
    box-shadow: none !important;
    fieldset { border-color: #DEE1EA !important; }
  }
  &.v-input--is-focused .v-input__slot fieldset {
    border-color: #009E60 !important;
    border-width: 2px !important;
  }
  input, textarea {
    font-size: 14px;
    color: #25325F;
    &::placeholder { color: #9BA1B5; }
  }
}

.loader-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.loader-content { text-align: center; }
.loader-text { color: #6B759A; font-size: 14px; font-weight: 500; }
</style>
